(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.MirroredBackdropCore = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';
  const productTypes = Object.freeze({
    us: ['Fabric&fleece Backdrop'], fr: ['Fabric&fleece Backdrop'], es: ['Fabric&fleece Backdrop'],
    uk: ['fabric&fleece backdrop'], au: ['Fabric & Fleece Backdrops'],
    de: ['Hintergründe&Fleece', 'Stoff- und Fleece-Hintergrund'],
  });
  function eligible(site, type) { return (productTypes[site] || []).includes(type); }
  function materialForVariant(variant) {
    const sku = String(variant?.sku || '').trim().toUpperCase();
    if (/^(BH1|B1)/.test(sku)) return 'microfiber';
    if (/^(BH8|B8)/.test(sku)) return 'fleece';
    const text = (variant?.options || [variant?.option1, variant?.option2, variant?.option3, variant?.title])
      .filter(Boolean).join(' ').normalize('NFKC').toLowerCase();
    const microfiber = /\bmicrofib(?:er|re)\b|\bmikrofaser\b/.test(text);
    const fleece = /\bfleece\b|\bpol(?:aire|ar)\b/.test(text);
    return microfiber === fleece ? null : microfiber ? 'microfiber' : 'fleece';
  }
  function checkedRect(rect) {
    if (!rect || !['x','y','width','height'].every(k => typeof rect[k] === 'number' && Number.isFinite(rect[k])))
      throw new Error('Invalid crop coordinates.');
    const {x,y,width,height} = rect;
    if (x < 0 || y < 0 || width <= 0 || height <= 0 || x + width > 1 + 1e-9 || y + height > 1 + 1e-9)
      throw new Error('Crop coordinates are outside the source image.');
    return {x,y,width,height};
  }
  // This operation is its own inverse: the persisted rectangle always uses source coordinates.
  function mirrorRect(rect) {
    const r = checkedRect(rect);
    return {...r, x: Math.max(0, 1 - r.x - r.width)};
  }
  function sourceRect(displayRect, mirrored) { return mirrored ? mirrorRect(displayRect) : checkedRect(displayRect); }
  function pixelRect(rect, width, height) {
    const r = checkedRect(rect);
    if (![width,height].every(v => Number.isSafeInteger(v) && v > 0)) throw new Error('Invalid image size.');
    const x = Math.round(r.x * width), y = Math.round(r.y * height);
    const w = Math.round((r.x + r.width) * width) - x;
    const h = Math.round((r.y + r.height) * height) - y;
    if (w < 1 || h < 1) throw new Error('Crop region is empty.');
    return {x,y,width:w,height:h};
  }
  function imageForVariant(variant, featuredImage) {
    const image = variant?.featured_image || variant?.featured_media?.preview_image || featuredImage;
    return typeof image === 'string' ? {src:image} : image || null;
  }
  return Object.freeze({productTypes,eligible,materialForVariant,checkedRect,mirrorRect,sourceRect,pixelRect,imageForVariant});
});
